import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NodeId } from 'web';
import { colorMap } from '@/colors';
import { DynamicNode2 } from '@/components/Nodes/DynamicNode/DynamicNode2';
import { I18N_KEYS } from '@/language/keys';
import { useUserWorkflowRole } from '@/state/workflow.state';
import { InvertData } from '@/types/node';
import { useNodeSetAsCover } from '../hooks/useNodeSetAsCover';
import { NodeViewer } from '../Shared/FileViewer';
import { hasEditingPermissions } from '../Utils';
import type { MenuAction } from '@/components/Menu/Actions';

function InvertNode({ id, data }: { id: NodeId; data: InvertData }) {
  const { t } = useTranslation();
  const role = useUserWorkflowRole();
  const editable = hasEditingPermissions(role, data);
  const { canSetPoster, generateNodePreviewImageAndSetPoster } = useNodeSetAsCover(id, 'invert');

  const coverMenuItems = useMemo<MenuAction[]>(
    () => [
      {
        name: t(I18N_KEYS.RECIPE_MAIN.NODES.PREVIEW_NODE.SET_AS_COVER),
        action: () => {
          void generateNodePreviewImageAndSetPoster();
        },
      },
    ],
    [generateNodePreviewImageAndSetPoster, t],
  );
  const contextMenuItems = editable && canSetPoster ? coverMenuItems : undefined;

  return (
    <DynamicNode2 id={id} data={data} className="invert" handleColor={colorMap.get(data.color)}>
      <NodeViewer id={id} contextMenuItems={contextMenuItems} />
    </DynamicNode2>
  );
}

export default InvertNode;
